import { useRef } from 'react';
import { useParams } from 'react-router';
import { DatabasePageParams } from '../../pages/DatabasePage/types';
import { ImageContentCombinedProps } from './types';

const usePresenter = (props: ImageContentCombinedProps): ImageContentCombinedProps => {
  const { handleDoubleClick, value, uploadAsset } = props;
  const { databaseSlug, tableSlug } = useParams<DatabasePageParams>();
  const inputFileRef = useRef<HTMLInputElement>(null);

  const handleFileChanges = async (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (file && databaseSlug && tableSlug) {
      await uploadAsset?.(databaseSlug, tableSlug, file, 'images');
    }
  };

  const handleImageClick = (event?: React.MouseEvent<HTMLElement>) => {
    event?.preventDefault();
    if (inputFileRef.current) {
      inputFileRef.current.click();
    }
  };

  const onDoubleClick = (event?: React.MouseEvent<HTMLDivElement>) => {
    handleDoubleClick?.(event);
    if (inputFileRef.current) {
      inputFileRef.current.click();
    }
  };

  return {
    ...props,
    button: {
      icon: {
        asset: value ? 'Replace' : 'AddOutline',
      },
      onMouseDown: handleImageClick,
    },
    handleDoubleClick: onDoubleClick,
    handleFileChanges,
    inputFileRef,
    image: {
      imageSrc: value as string,
    },
  };
};

export default usePresenter;
